import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 25 25'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='M8.492 20.138h8.192v-3q0-1.708-1.194-2.921-1.194-1.215-2.902-1.214-1.708 0-2.902 1.214t-1.194 2.92zm4.096-8.865q1.708 0 2.902-1.214t1.194-2.921v-3H8.492v3q0 1.707 1.194 2.921 1.194 1.215 2.902 1.214m-7.5 10.365v-1.5h1.904v-3q0-1.689.924-3.074.924-1.386 2.449-1.926-1.525-.55-2.45-1.93a5.4 5.4 0 0 1-.923-3.07v-3H5.088v-1.5h15v1.5h-1.904v3a5.4 5.4 0 0 1-.924 3.07q-.924 1.38-2.45 1.93 1.526.54 2.45 1.926t.924 3.074v3h1.904v1.5z'
    />
  </svg>
)
export default SvgComponent
